export default __webpack_public_path__ + "static/media/Leggings of the Furious Swipe.a57f4282.jpg";